import CollapseList from './CollapseList';

export default CollapseList;
